import Amplify from 'aws-amplify';

Amplify.configure({
  Auth: {
    region: 'eu-west-1',
    userPoolId: process.env.cognitoPool,
    userPoolWebClientId: process.env.cognitoAppClient,
  },
});
